import React from 'react';

import { AccountControlsLayoutComponent } from 'design/accountControlsLayout';
import { useAccountEmail } from 'hooks/useAccountEmail';
import { TextComponent } from 'design/text/textComponents';
import { ClickControlComponent } from 'design/clickControl/clickControlComponents';
import { useHistory } from 'react-router';
import { routes } from 'utils/routes';
import { ReactComponent as SignOutIcon } from 'svg/sign-out.svg';

type Props = { redirectOnSignedOutTo?: string };

export const AccountControls = (props: Props) => {
  const { redirectOnSignedOutTo } = props;

  const history = useHistory();

  const signOut = React.useCallback(() => {
    history.push(routes.signOut({ redirect: redirectOnSignedOutTo }));
  }, [history, redirectOnSignedOutTo]);

  const goToRoot = React.useCallback(() => {
    history.push('/');
  }, [history]);

  const email = useAccountEmail();

  if (!email) {
    return null;
  }

  return (
    <AccountControlsLayoutComponent
      email={
        <ClickControlComponent onClick={goToRoot}>
          <TextComponent>{email}</TextComponent>
        </ClickControlComponent>
      }
      action={
        <ClickControlComponent onClick={signOut}>
          <TextComponent>
            <SignOutIcon />
          </TextComponent>
        </ClickControlComponent>
      }
    />
  );
};
